import { WidgetStyles } from 'components/Visualization/CDashboard/types';

export const widgetStyles: WidgetStyles = {
  root: { boxShadow: 'none' },
};
